import { FC } from 'react';

export const TooBroadText: FC<{ total: number }> = ({ total }) => {
  return total > 50 ? (
    <div className="text-text500 pt-5 text-center text-xs">
      Your search returned a large number of results. To help you find what
      you&apos;re looking for, consider adding more keywords or using filters.
    </div>
  ) : null;
};
